import PropTypes from "prop-types";
import { Alert, Chip, Paper, Stack, Typography } from "@mui/material";

import { toJalaliFullDate } from "../../../../../middleware/middleware";

const pick = (obj, ...keys) => {
  if (!obj) return undefined;
  for (const k of keys) {
    if (obj[k] !== undefined && obj[k] !== null && obj[k] !== "") return obj[k];
  }
  return undefined;
};

const typeColor = (title) => {
  const t = String(title || "").toLowerCase();
  if (t.includes("لغو") || t.includes("رد")) return "error";
  if (t.includes("تایید")) return "success";
  if (t.includes("پیگیری")) return "warning";
  if (t.includes("ارجاع")) return "info";
  return "default";
};

/**
 * Operator action audit timeline from SLN_RequestUpdateHistories.
 */
const RequestOperatorActionTimeline = ({ items }) => {
  const rows = Array.isArray(items) ? items : [];
  if (!rows.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        هنوز اقدام کارشناسی با لاگ ثبت نشده است.
      </Typography>
    );
  }

  return (
    <Stack spacing={1.25}>
      <Alert severity="info" sx={{ py: 0.5 }}>
        هر تأیید، رد، لغو یا تغییر وضعیت با نام کاربری، ساعت و IP ثبت می‌شود.
      </Alert>
      {rows.map((item) => {
        const id = pick(item, "id", "Id");
        const typeTitle =
          pick(item, "updateTypeTitle", "UpdateTypeTitle") || "اقدام";
        const userName =
          pick(item, "fullName", "FullName", "userName", "UserName", "createBy", "CreateBy") ||
          "نامشخص";
        const ip = pick(item, "callerIp", "CallerIp", "createFrom", "CreateFrom");
        const when = pick(item, "createOn", "CreateOn");
        const description = pick(item, "description", "Description") || "";

        return (
          <Paper key={id || `${userName}-${when}`} variant="outlined" sx={{ p: 1.5 }}>
            <Stack spacing={0.75}>
              <Stack direction="row" flexWrap="wrap" gap={0.75} alignItems="center">
                <Chip size="small" color={typeColor(typeTitle)} label={typeTitle} />
                <Typography variant="body2" fontWeight={700}>
                  {userName}
                </Typography>
                {when ? (
                  <Typography variant="caption" color="text.secondary">
                    {toJalaliFullDate(when)}
                  </Typography>
                ) : null}
                {ip ? (
                  <Typography variant="caption" color="text.secondary">
                    IP: {ip}
                  </Typography>
                ) : null}
              </Stack>
              {description ? (
                <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "pre-wrap" }}>
                  {description}
                </Typography>
              ) : null}
            </Stack>
          </Paper>
        );
      })}
    </Stack>
  );
};

RequestOperatorActionTimeline.propTypes = {
  items: PropTypes.array,
};

export default RequestOperatorActionTimeline;
